// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__2mIp_","pulse":"Skeleton_pulse__326tM"};